import React from 'react';
import { TIMEZONE as TimeZoneContext } from '../contexts';

export const WithCurrentTimeZone = WrappedComponent => props => (
  <TimeZoneContext.Consumer>
    {value => <WrappedComponent {...props} currentTimeZone={value} />}
  </TimeZoneContext.Consumer>
);
